// extracted by mini-css-extract-plugin
export default {"root":"vjyJDJnO","form":"MsuvfxQW","formTitle":"io1Fokvv","submitButton":"ONfjRNkV"};